// extracted by mini-css-extract-plugin
module.exports = {"row":"styles_row__-0ran","header":"styles_header__1XCZn","table":"styles_table__w4Rz6"};